module.exports = __webpack_public_path__ + "static/media/img3.564a92fe.jpg";